<template>
    <div v-if="loading" class="text-center p-5 w-100">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: Boolean
    }
}
</script>
